/**
 * @fileoverview Row component React interface.
 * @author Lisa Liu (lliu@yext.com)
 */
// @ts-nocheck
goog.declareModuleId('yext.ui.components.layout.Row');

import {classNames} from '/ui/lib/classnames';

const elemRoot = 'ui-layout';
const rowRoot = `${elemRoot}__row`;

/**
 * @param {{children: (React.ReactNode|undefined),
 *          rowClasses: (Array<string>|string|undefined),
 *        }} props
 * @returns {?}
 */

/**
 * @deprecated
 * @suppress {checkTypes}
 * @param {?} props
 * @return {React.ReactElement}
 */
export function Row({
  children,
  rowClasses,
}) {
  const allRowClasses = classNames(
    rowRoot,
    rowClasses,
  );

  return (
    <div className={allRowClasses}>
      {children}
    </div>
  );
}
